import { CreditCard, Plus } from 'lucide-react';
import { useAccountStore } from '../../stores/useAccountStore';
import s from './Pages.module.css';

export function SubscriptionsPage() {
  const subscriptions = useAccountStore(a => a.subscriptions);
  // Provider field distinguishes creator-owned vs external
  const created = subscriptions.filter(sub => !sub.provider);
  const purchased = subscriptions.filter(sub => !!sub.provider);

  return (
    <div className={s.page}>
      <div className={s.pageHeader}>
        <h1 className={s.pageTitle}>Subscriptions</h1>
        <p className={s.pageSubtitle}>Services you&#39;ve created or subscribed to.</p>
      </div>

      <div className={s.statsRow}>
        <div className={s.statCard}>
          <div className={s.statLabel}>Total</div>
          <div className={s.statValue}>{subscriptions.length}</div>
        </div>
        <div className={s.statCard}>
          <div className={s.statLabel}>Created</div>
          <div className={s.statValue}>{created.length}</div>
        </div>
        <div className={s.statCard}>
          <div className={s.statLabel}>Subscribed</div>
          <div className={s.statValue}>{purchased.length}</div>
        </div>
        <div className={s.statCard}>
          <div className={s.statLabel}>Active</div>
          <div className={s.statValue}>{subscriptions.filter(sub => sub.status === 'active').length}</div>
        </div>
      </div>

      {/* Created */}
      <div className={s.sectionHeader}>
        <h2 className={s.sectionTitle}>Created by You</h2>
        <button className={s.btnPrimary}><Plus size={14} /> Create Subscription</button>
      </div>

      {created.length === 0 ? (
        <div className={s.emptyState}>
          <div className={s.emptyIcon}><CreditCard size={48} /></div>
          <div className={s.emptyTitle}>No created subscriptions</div>
          <div className={s.emptyDesc}>Monetize your deployed contracts by creating subscription tiers.</div>
        </div>
      ) : (
        <div className={s.cardGrid}>
          {created.map(sub => (
            <div key={sub.id} className={s.card}>
              <div className={s.cardTitle}>{sub.planName}</div>
              <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                <span className={`${s.badge} ${sub.status === 'active' ? s.badgeSuccess : s.badgeNeutral}`}>{sub.status}</span>
                <span className={`${s.badge} ${s.badgeInfo}`}>{sub.amount} NAT/{sub.cadence}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Purchased */}
      <div className={s.sectionHeader} style={{ marginTop: 40 }}>
        <h2 className={s.sectionTitle}>Your Subscriptions</h2>
      </div>

      {purchased.length === 0 ? (
        <div className={s.emptyState}>
          <div className={s.emptyIcon}><CreditCard size={48} /></div>
          <div className={s.emptyTitle}>No subscriptions</div>
          <div className={s.emptyDesc}>Browse prefabs and services to find subscriptions.</div>
        </div>
      ) : (
        <div className={s.cardGrid}>
          {purchased.map(sub => (
            <div key={sub.id} className={s.card}>
              <div className={s.cardTitle}>{sub.planName}</div>
              {sub.provider && <div className={s.cardDesc}>Provider: {sub.provider}</div>}
              <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                <span className={`${s.badge} ${sub.status === 'active' ? s.badgeSuccess : sub.status === 'cancelled' ? s.badgeDanger : s.badgeNeutral}`}>{sub.status}</span>
                <span className={`${s.badge} ${s.badgeInfo}`}>{sub.amount} NAT/{sub.cadence}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
